import React, { useEffect, useRef, useState } from "react";
import Form from "../Form/Form";
import {
  CARNET_DE_EXTRANJERIA,
  DNI,
  PASAPORTE,
  RUC,
} from "../Form/constants/constants";
import {
  validateCarnetDeExtranjeriaAndPasaport,
  validateDNIAndRUC,
} from "./validations/validations";
import { postCreateNewClient } from "@Services/clients/postCreateNewClient";
// @ts-ignore
import { SlideNotification } from "@viuti/recursos";
import { useClientsCategories } from "./hook/useClientsCategories";

const FormCreateNewClient = ({ isDisabled, setIsDisabled, nextClick }) => {
  const [isLoadingCreateNewClient, setIsLoadingCreateNewClient] =
    useState(false);
  const [searchingInReniec, setSearchingInReniec] = useState(false);
  const [form, setForm] = useState({
    name: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    codeCountryPhone: "51",
    phoneRefused: false,
    documentType: DNI,
    documentNumber: "",
    categoryClientId: "",
    sex: "",
    birthdate: "",
    address: "",
  });
  const [status, setStatus] = useState({
    error: false,
    validated: false,
    loading: false,
    message: "",
  });
  const [stateResponse, setStateResponse] = useState<any>({
    message: "",
    status: 0,
  });
  const { categories } = useClientsCategories(setStateResponse);

  const modalRef = useRef(null);
  const ESCAPE_KEY = 27;
  const [debouncedDocumentNumber, setDebouncedDocumentNumber] = useState(
    form.documentNumber
  );

  useEffect(() => {
    setForm({
      name: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      codeCountryPhone: "51",
    phoneRefused: false,
      documentType: DNI,
      documentNumber: "",
      categoryClientId: "",
      sex: "",
      birthdate: "",
      address: "",
    });
    setSearchingInReniec(false); // Resetear el estado de búsqueda al abrir/cerrar el modal
  }, [isDisabled]);

  useEffect(() => {
    setStatus({
      error: false,
      validated: false,
      loading: false,
      message: "",
    });
  }, [form.documentNumber, form.documentType]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedDocumentNumber(form.documentNumber);
    }, 500); // 500ms de delay

    return () => clearTimeout(timer);
  }, [form.documentNumber]);

  const validateDocumentNumber = async () => {
    // Solo validar si hay número de documento y tipo de documento
    if (
      !form.documentNumber ||
      form.documentNumber === "" ||
      !form.documentType ||
      form.documentType === ""
    ) {
      return;
    }

    if (
      (form.documentType === DNI && form.documentNumber.length === 8) ||
      (form.documentType === RUC && form.documentNumber.length === 11)
    ) {
      setSearchingInReniec(true);
      await validateDNIAndRUC(setStatus, status, setForm, form);
      setSearchingInReniec(false);
    } else if (
      (form.documentType === CARNET_DE_EXTRANJERIA ||
        form.documentType === PASAPORTE) &&
      form.documentNumber.length > 2
    ) {
      // No activamos searchingInReniec para C.E./Pasaporte: a diferencia de
      // DNI/RUC (que consultan RENIEC y autocompletan nombre/apellido), esta
      // verificacion solo comprueba si el cliente ya existe y no autocompleta
      // nada. Deshabilitar el campo aqui cortaba la escritura del documento
      // apenas se ingresaba el 3er caracter, dando la sensacion de que el
      // numero quedaba limitado a pocos digitos.
      await validateCarnetDeExtranjeriaAndPasaport(setStatus, status, form);
    }
  };

  useEffect(() => {
    validateDocumentNumber();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedDocumentNumber]); // Cambiamos a debouncedDocumentNumber

  const postNewClient = async () => {
    setIsLoadingCreateNewClient(true);
    const res = await postCreateNewClient(form);
    if (res.isSuccess) {
      nextClick(res.data);
      setStateResponse({
        message: `Cliente ${form.name} creado de manera exitosa`,
        status: 200,
      });

      // Resetear completamente el formulario después de crear el cliente
      setForm({
        name: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        codeCountryPhone: "51",
    phoneRefused: false,
        documentType: DNI,
        documentNumber: "",
        categoryClientId: "",
        sex: "",
        birthdate: "",
        address: "",
      });
      setStatus({
        error: false,
        validated: false,
        loading: false,
        message: "",
      });
      setSearchingInReniec(false);
      setIsLoadingCreateNewClient(false);
      setIsDisabled(false);
    } else {
      setStateResponse({ message: res.message, status: 400 });
      setIsLoadingCreateNewClient(false);
      setSearchingInReniec(false); // Resetear el estado de búsqueda
    }
  };

  // useEffect for click outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        setIsDisabled(false);
        setSearchingInReniec(false); // Resetear el estado de búsqueda al cerrar
      }
    };

    const handleKeyPress = (e) => {
      if (e.keyCode === ESCAPE_KEY) {
        setIsDisabled(false);
        setSearchingInReniec(false); // Resetear el estado de búsqueda al cerrar
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleKeyPress);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [modalRef, setIsDisabled]);

  return (
    <>
      <Form
        backClick={() => {
          setIsDisabled(false);
          setSearchingInReniec(false); // Resetear el estado de búsqueda al cerrar
        }}
        nextClick={postNewClient}
        form={form}
        setForm={setForm}
        status={status}
        textButton="Guardar"
        isLoading={isLoadingCreateNewClient}
        categories={categories}
        searchingInReniec={searchingInReniec}
      />
      <SlideNotification
        state={stateResponse}
        clearStatus={() => setStateResponse({ message: "", status: 0 })}
      />
    </>
  );
};

export default FormCreateNewClient;
